function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Allows the user to add custom genre, subgenre or mood tags to individual tracks, rate songs and easily visualize all playlists a track is part of. Create custom playlists based on filtering or manually adding and reordering tracks. Perfect for people that have medium to large music libraries and like to easily keep their favorite playlists up to date.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"name":"MoodMusic","tech":["React","Redux","Node","Spotify API","MaterialUI"],"cover":"moodmusic.png","github":"https://github.com/pizzadudez/MoodMusic","hosted":"https://moodmusic.vladalbert.com","readme":false},
    
      body: "Allows the user to add custom genre, subgenre or mood tags to individual tracks, rate songs and easily visualize all playlists a track is part of. Create custom playlists based on filtering or manually adding and reordering tracks. Perfect for people that have medium to large music libraries and like to easily keep their favorite playlists up to date.\r\n",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }